import api from '../../apiConfig/apiConfig';
import { Post, Get, Put, Delete, Patch } from '../base/baseAjax';
//获取默认邮箱列表
let dropDownList = param => {
	return Post({
		url: api.customer.dropDownList,
		bodyParam: param,
	});
};
//获取访客每月识别数
let monthdistinguishnum = param => {
	return Post({
		url: api.customer.monthdistinguishnum,
		PathParam: param,
	});
};
//修改访客识别中结束日期和最大数量
let visitors_to_identify = (param, ID) => {
	return Patch({
		url: api.customer.visitors_to_identify,
		PathParam: { id: ID.id },
		bodyParam: param,
	});
};
let addCustomer = param => {
	return Post({
		url: api.customer.addCustomer,
		bodyParam: param,
	});
};
let editCustomer = param => {
	return Put({
		url: api.customer.editCustomer,
		bodyParam: param,
	});
};

let getCustomerDetail = param => {
	return Get({
		url: api.customer.getCustomerDetail,
		PathParam: param,
	});
};
let searchCustomer = param => {
	return Get({
		url: api.customer.searchCustomer,
		UrlParam: param,
	});
};
// 客户行业
let getIndustry = param => {
	return Post({
		url: api.customer.getIndustry,
		UrlParam: param,
	});
};
// 外贸行业
let foreigntrade = param => {
	return Get({
		url: `${api.customer.foreigntrade}/${param.parentId}`,
	});
};
let addCustomerAccount = param => {
	return Post({
		url: api.customer.addCustomerAccount,
		bodyParam: param,
	});
};
let editCustomerAccount = (body, path) => {
	return Put({
		url: api.customer.editCustomerAccount,
		bodyParam: body,
		PathParam: path,
	});
};
let toggleMsgStatus = id => {
	return Patch({
		url: api.customer.toggleMsgStatus + id,
	});
};
let deleteCustomerAccount = id => {
	return Delete({
		url: api.customer.deleteCustomerAccount + id,
	});
};
let getCustomerAccountDetail = id => {
	return Get({
		url: api.customer.getCustomerAccount + id,
	});
};

let getAddCustomerList = () => {
	return Post({
		url: api.customer.getAddCustomerList,
	});
};

let getCustomerAccountListDetail = id => {
	return Get({
		url: api.customer.getCustomerAccountListDetail + id,
	});
};

let getTempCustomer = params => {
	return Post({
		url: api.customer.getTempCustomer,
		bodyParam: params,
	});
};

// let getDropdownList = params => {
//   return Get({
//     url: api.customer.getDropdownList,
//     UrlParam: params
//   })
// }

let getOrderList = params => {
	return Post({
		url: api.customer.getOrderList,
		bodyParam: params,
	});
};
let getHaveCustomerList = params => {
	return Post({
		url: api.customer.getHaveCustomerList,
		bodyParam: params,
	});
};

let getOrderListDeatail = id => {
	return Get({
		url: api.customer.getOrderListDeatail + id,
	});
};

let getTempOrder = params => {
	return Post({
		url: api.customer.getTempOrder,
		bodyParam: params,
	});
};

let getRenewalOrder = id => {
	return Post({
		url: api.customer.getRenewalOrder + id,
	});
};

let getCustomerpermissiondetail = id => {
	return Get({
		url: api.customer.getCustomerpermissiondetail + id,
	});
};

let setCustomerpermissiondetail = (id, data) => {
	return Patch({
		url: api.customer.setCustomerpermissiondetail + id,
		bodyParam: data,
	});
};
// 获取小程序访问权限
let getAppletAccess = id => {
	return Patch({
		url: api.customer.getAppletAccess + id,
	});
};

let servicedetail = id => {
	return Get({
		url: api.customer.servicedetail,
		PathParam: {
			id,
		},
	});
};
let serviceEdit = params => {
	return Put({
		url: api.customer.serviceEdit,
		PathParam: {
			id: params.id,
		},
		bodyParam: params,
	});
};

let updatelangeageNum = params => {
	return Patch({
		url: api.customer.updatelangeageNum,
		PathParam: {
			id: params.id,
		},
		bodyParam: params,
	});
};

// 订单详情
let orderDetail = id => {
	return Get({
		url: api.customer.orderDetail,
		PathParam: {
			id,
		},
	});
};
// 订单删除
let orderDelete = param => {
	return Patch({
		url: api.customer.orderDelete,
		PathParam: {
			id: param.id,
		},
		bodyParam: {
			code: param.code,
			userId: param.userId,
		},
	});
};

// 获取验证码
let verificationcode = id => {
	return Get({
		url: api.customer.verificationcode + id,
	});
};

// 设置到期时间
let expirationtime = param => {
	return Patch({
		url: api.customer.expirationtime,
		PathParam: {
			id: param.id,
		},
		bodyParam: {
			code: param.code,
			date: param.date,
			userId: param.userId,
		},
	});
};

// 主管下拉
let leaders = () => {
	return Get({
		url: api.customer.leaders,
	});
};

// 网站域名
let domainname = param => {
	return Get({
		url: api.customer.domainname + param,
	});
};

// 网站域名
let emailvenify = param => {
	return Post({
		url: api.customer.emailvenify,
		bodyParam: param,
	});
};

let createPersonMail = param => {
	return Post({
		url: api.customer.createPersonMail,
		bodyParam: param,
	});
};

let resetPassword = param => {
	return Post({
		url: api.customer.resetPassword,
		bodyParam: param,
	});
};

let resultsReportList = param => {
	return Post({
		url: api.customer.resultsReportList,
		bodyParam: param,
	});
};
let reportDetail = param => {
	return Post({
		url: `${api.customer.reportDetail}?customerId=${param.customerId}`,
		bodyParam: param,
	});
};

let resetEmail = param => {
	return Patch({
		url: api.customer.resetEmail,
		bodyParam: param,
	});
};
let renewalRateChartData = param => {
	return Get({
		url: `${api.customer.renewalRateChartData}/${param.serviceId}`,
	});
};

let downloadRenewalRate = param => {
	return Post({
		url: api.customer.downloadRenewalRate,
		bodyParam: param,
		config: {
			timeout: 60000,
			responseType: 'blob',
		},
	});
};

let rightControlList = params => {
	return Post({
		url: api.customer.rightControlList,
		bodyParam: params,
	});
};

let setRightControl = params => {
	return Patch({
		url: api.customer.setRightControl,
		PathParam: params,
	});
};
// 获取服务日志
let serviceLog = params => {
	return Get({
		url: api.customer.serviceLog,
		UrlParam: params,
	});
};

let getPackagedropdownlist = () => {
	return Get({
		url: api.customer.getPackagedropdownlist,
	});
};

let defaultRoleList = params => {
	return Post({
		url: api.customer.defaultRoleList,
		bodyParam: params,
	});
};

function edmResidueNum(params) {
	return Patch({
		url: api.customer.edmResidueNum,
		PathParam: { id: params.id },
		bodyParam: params,
	});
}

// 设置云盘容量
function setCloudDiskNum(params) {
	return Patch({
		url: api.customer.setCloudDiskNum,
		PathParam: { id: params.id },
		bodyParam: params,
	});
}

// AI自动回复配置botId
function setAiReplyBotId(params) {
	return Patch({
		url: api.customer.setAiReplyBotId,
		PathParam: { id: params.id },
		bodyParam: params,
	});
}

// 设置-竞争对手分析
function setCompAnalysisNum(params) {
	return Patch({
		url: api.customer.setCompAnalysisNum,
		PathParam: { id: params.id },
		bodyParam: params,
	});
}

// 设置-AI创作
function setAiCreativeNum(params) {
	return Patch({
		url: api.customer.setAiCreativeNum,
		PathParam: { id: params.id },
		bodyParam: params,
	});
}

// --服务单标签
// 服务标签列表
function serviceTagList() {
	return Get({
		url: api.customer.serviceTagList,
	});
}

// 设置服务单标签
function addServiceTag({ id, tagIdList }) {
	return Patch({
		url: api.customer.addServiceTag,
		PathParam: {
			id,
		},
		bodyParam: tagIdList,
	});
}

//SEO排名监控更新
function setServiceSeo(params) {
	return Put({
		url: api.customer.setServiceSeo,
		PathParam: { id: params.id },
		bodyParam: params,
	});
}

//设置-SEO关键词数量
function setSeoKeyWordNum(params) {
	return Patch({
		url: api.customer.setSeoKeyWordNum,
		PathParam: { id: params.id },
		bodyParam: params,
	});
}

// SEO排名监控详情
function getServiceSeoDetail(id) {
	return Get({
		url: api.customer.getServiceSeoDetail,
		PathParam: { id },
	});
}
// 服务单中智能网站访客识别查看日期和剩余数量
function getRemainList(params) {
	return Post({
		url: api.customer.remainList,
		bodyParam: params,
	});
}
// editRemain:'/service/function-remain/function_num/{id}', // 编辑服务单中智能网站访客识别的剩余数量
function editRemain(id, params) {
	Patch({
		url: api.customer.editRemain,
		PathParam: {
			id,
		},
		bodyParam: params,
	});
}

export default {
	dropDownList,
	monthdistinguishnum,
	visitors_to_identify,
	addCustomer,
	editCustomer,
	getCustomerDetail,
	searchCustomer,
	getIndustry,
	foreigntrade,
	addCustomerAccount,
	editCustomerAccount,
	toggleMsgStatus,
	deleteCustomerAccount,
	getCustomerAccountDetail,
	getAddCustomerList,
	getCustomerAccountListDetail,
	getTempCustomer,
	// getDropdownList,
	getOrderList,
	getHaveCustomerList,
	getOrderListDeatail,
	getTempOrder,
	getRenewalOrder,
	getAppletAccess,
	getCustomerpermissiondetail,
	setCustomerpermissiondetail,
	servicedetail,
	serviceEdit,
	updatelangeageNum,
	orderDetail,
	orderDelete,
	verificationcode,
	expirationtime,
	leaders,
	domainname,
	emailvenify,
	createPersonMail,
	resetPassword,
	resultsReportList,
	reportDetail,
	resetEmail,
	renewalRateChartData,
	downloadRenewalRate,
	rightControlList,
	setRightControl,
	serviceLog,
	getPackagedropdownlist,
	defaultRoleList,
	edmResidueNum,
	setCloudDiskNum,
	setAiReplyBotId,
	setCompAnalysisNum,
	setAiCreativeNum,
	serviceTagList,
	addServiceTag,
	setServiceSeo,
	setSeoKeyWordNum,
	getServiceSeoDetail,
	getRemainList,
	editRemain,
};
